import {NgModule} from '@angular/core';
import {MeasurementsFeatureComponent} from './measurements-feature/measurements-feature.component';
import {MeasurementsService} from './measurements.service';
import {SharedProviderModule} from '../shared/shared.module';
import {MeasurementsLiveComponent} from './measurements-live/measurements-live.component';
import {NgxChartsModule} from '@mipro/ngx-charts';
import {OverlayPanelModule} from '../components/overlay-panel/overlay-panel.module';
import {AutomationService} from '../automation/automation.service';
import {ElementUtilsModule} from '../element-utils/element-utils.module';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { MeasurementsTableComponent } from './measurements-table/measurements-table.component';
import { NeveMeasurementsModule } from '~app/custom/neve/measurements/neve-measurements.module';

@NgModule({
  imports: [
    ElementUtilsModule,
    OverlayPanelModule,
    NgxChartsModule,
    NgbDatepickerModule,
    SharedProviderModule,
    NeveMeasurementsModule
  ],
  declarations: [MeasurementsFeatureComponent, MeasurementsLiveComponent, MeasurementsTableComponent],
  exports: [MeasurementsFeatureComponent, MeasurementsLiveComponent],
  providers: [MeasurementsService, AutomationService]
})
export class MeasurementsModule {
}
